module.exports = __webpack_public_path__ + "static/img/freshman-python__en.3aa121d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshman-python__en.png
// module id = +yBC
// module chunks = 1